import React, {useState, useRef, useEffect} from 'react'
import {Block} from 'jsxstyle'
import {ReactComponent as SightcallLogo} from '../../common/assets/sightcall-logo.svg'
import {useCopilotContext} from './CopilotContext'
import ChatPopup from './CopilotChatPopup'

const CopilotChatButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonRef = useRef<HTMLDivElement>(null)
  const popupRef = useRef<HTMLDivElement>(null)
  const {fetchConversations} = useCopilotContext()
  const hasLoadedRef = useRef(false)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const targetElement = event.target as Element
      const isInsideDialog = targetElement.closest('[role="dialog"]') !== null
      const isDialogBackdrop = targetElement.classList.contains('backdrop') || targetElement.getAttribute('aria-hidden') === 'true'

      if (
        isOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node) &&
        !isInsideDialog &&
        !isDialogBackdrop
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  useEffect(() => {
    if (isOpen && !hasLoadedRef.current) {
      fetchConversations()
      hasLoadedRef.current = true
    }

    if (!isOpen) {
      hasLoadedRef.current = false
    }
  }, [isOpen, fetchConversations])

  return (
    <>
      <Block
        props={{
          ref: buttonRef,
          onClick: () => setIsOpen(!isOpen),
        }}
        position="fixed"
        bottom="90px"
        right="20px"
        width="55px"
        height="55px"
        borderRadius="50%"
        backgroundColor="#0070f3"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
        cursor="pointer"
        zIndex={1000}
        transition="all 0.3s ease"
      >
        <SightcallLogo width={36} height={16} color="#FFFFFF" />
      </Block>

      {isOpen && <ChatPopup ref={popupRef} onClose={() => setIsOpen(false)} />}
    </>
  )
}

export default CopilotChatButton
